import { Select } from 'antd';
import i18next from "i18next";
import { useTranslation } from 'react-i18next';
import { getCookie } from 'typescript-cookie';
import "./changeLang.css";

const { Option } = Select;

export const ChangeLang = () => {
  const { t } = useTranslation();

  const handleLanguageChange = (language: any) => {
    i18next.changeLanguage(language);
  };

  return (

      <Select
        className='changeLang'
        style={{ minWidth: 100, marginRight: 5 }}
        value={getCookie("i18next")}
        onChange={handleLanguageChange}
      >
        <Option value="ky">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img
              src="/flags/kg.svg"
              alt="Кырг"
              style={{ width: 16, height: 16, borderRadius: '50%' }}
            />
            Кырг
          </div>
        </Option>
        <Option value="ru">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img
              src="/flags/rus.svg"
              alt="Русс"
              style={{ width: 16, height: 16, borderRadius: '50%' }}
            />
            Русс
          </div>
        </Option>
      </Select>
  );
};
